module.exports = __webpack_public_path__ + "img/sec1.6a681a0b.png";